<!-- New Breadcrumb -->
<section class="new-breadcrumb" *ngIf="breadcrumb.showNewBreadcrumb">
    <a [uiSref]="breadcrumb.backStateName" [uiParams]="breadcrumb.backStateParams" class="new-breadcrumb-link">
        <span class="caret-left" aria-hidden="true"></span>
        <span>Back</span>
    </a>
</section>

<!-- Old Breadcrumb -->
<ng-container *ngIf="!breadcrumb.showNewBreadcrumb">
    <section *ngIf="breadcrumb.steps.length > 1">
        <ng-container *ngFor="let step of breadcrumb.steps; let last = last">
            <a *ngIf="!last" [uiSref]="step.stateName" [uiParams]="step.stateParams">{{ step.label }}</a>
            <span *ngIf="!last" class="separator">/</span>
            <span *ngIf="last">{{ step.label }}</span>
        </ng-container>
    </section>
    <section class="remove-padding" *ngIf="breadcrumb.steps.length == 1">
        <ng-container *ngFor="let step of breadcrumb.steps;">
            <div class="backto-breadcrumb" *ngIf="step.isBackTo">
                <a [uiSref]="step.stateName" [uiParams]="step.stateParams"><xm-media-image aria-hidden="true" [imageOptions]="step.cmsIcon" size="height"></xm-media-image>{{ step.label }}</a>
            </div>
        </ng-container>
    </section>
</ng-container>
